'use strict';

const removeDuplicatesFromArray = (array, prop) => {
    return array.filter(function(obj, pos, arr) {
        return arr.map((mapObj) => mapObj[prop]).indexOf(obj[prop]) === pos;
    });
};

module.exports = removeDuplicatesFromArray;
